import { render } from "./LoadPackagesPopup.vue?vue&type=template&id=7ecdcf4a&scoped=true&ts=true"
import script from "./LoadPackagesPopup.vue?vue&type=script&lang=ts"
export * from "./LoadPackagesPopup.vue?vue&type=script&lang=ts"

import "./LoadPackagesPopup.vue?vue&type=style&index=0&id=7ecdcf4a&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ecdcf4a"]])

export default __exports__